import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { FF2, SecuredInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const TIN = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()
  const noKnownAccountsInvolved = useWatch({ control, name: `subjectsInfo.${index1 as 0}.noKnownAccountsInvolved` })

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.institutionsInfo.${index2 as 0}.tin`}
      control={control}
      rules={{
        validate: (value) => (noKnownAccountsInvolved ? undefined : Validators.required.field(value))
      }}
      render={({ field }) => (
        <FF2
          required={!noKnownAccountsInvolved}
          field={field}
          label="Institution TIN"
          input={(props) => <SecuredInput {...props} disabled={noKnownAccountsInvolved} maxLength={25} />}
        />
      )}
    />
  )
}
